import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { createInvoiceColumns } from '../../../../utils/createInvoiceColumns';

const ListInvoices = ({ owner }) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const [refreshData, setRefreshData] = useState(false);

  const columns = createInvoiceColumns({
    t,
    dispatchAPI,
    message,
    setRefreshData,
    refreshData
  });

  return (
    <ListResource
      resourceName="customerinvoices"
      extraQuery={`customer=${owner.user._id}&type!=SUBSCRIPTION`}
      columns={columns}
      showEdit={false}
      withPageHeader={false}
      withCreateButton={false}
      customActionColumn
      forceRefresh={refreshData}
      path="/invoices/customers"
    />
  );
};

export default ListInvoices;

ListInvoices.propTypes = {
  owner: PropTypes.shape({
    user: PropTypes.shape({
      _id: PropTypes.string
    })
  }).isRequired
};
